import React, { useEffect, useState } from 'react';
import { Image } from '../../types';
import { getImages, getPublicImages } from '../../services/images';
import { getProjectImages } from '../../services/projects';
import ImagePicker from './ImagePicker';

interface ImagePickerContainerProps {
  open: boolean;
  onClose: () => void;
  onSelectImage: (image: Image) => void;
  tabs: ('Project' | 'User' | 'Public')[];
  projectId?: string;
}

function ImagePickerContainer({ open, onClose, onSelectImage, tabs, projectId }: ImagePickerContainerProps) {
  const [projectImages, setProjectImages] = useState<Image[]>([]);
  const [userImages, setUserImages] = useState<Image[]>([]);
  const [publicImages, setPublicImages] = useState<Image[]>([]);

  useEffect(() => {
    if (!open) return;

    async function fetchImages() {
      try {
        if (tabs.includes('Project') && projectId) {
          const imgs = await getProjectImages(projectId);
          setProjectImages(imgs);
        }
        if (tabs.includes('User')) {
          const imgs = await getImages();
          setUserImages(imgs);
        }
        if (tabs.includes('Public')) {
          const imgs = await getPublicImages();
          setPublicImages(imgs);
        }
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error('Failed to load images for picker:', error);
      }
    }

    fetchImages();
  }, [open, tabs, projectId]);

  return (
    <ImagePicker
      open={open}
      onClose={onClose}
      onSelectImage={onSelectImage}
      projectImages={tabs.includes('Project') ? projectImages : []}
      userImages={tabs.includes('User') ? userImages : []}
      publicImages={tabs.includes('Public') ? publicImages : []}
    />
  );
}

export default ImagePickerContainer; 